import { NavLink } from 'react-router-dom';
import styles from './Header.module.css'; 
import logo from './assets/logo.png'

const Header = () => {
  return (
    <div className={styles.headerWrapper}>
      <div className={styles.logoSection}>
        <img
          src={logo}
          alt="Deep Algorithms Logo"
          style={{ height: 50, marginRight: 10 }}
        />
      </div>
      <div className={styles.menuBar}>
        <NavLink
          to="/"
          className={({ isActive }) =>
            isActive ? `${styles.menuTab} ${styles.menuTabActive}` : styles.menuTab
          }
        >
          Register Complaint
        </NavLink>
        <NavLink
          to="/requestStatus"
          className={({ isActive }) =>
            isActive ? `${styles.menuTab} ${styles.menuTabActive}` : styles.menuTab
          }
        >
          Request Status
        </NavLink>
        {/* <NavLink
          to="/incidents"
          className={({ isActive }) =>
            isActive ? `${styles.menuTab} ${styles.menuTabActive}` : styles.menuTab
          }
        >
          Incidents
        </NavLink> */}
      </div>
    </div>
  );
};

export default Header;
